module.exports = __webpack_public_path__ + "static/media/bg13.9050079e.jpg";